import './index.css';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import { showToast } from '../../../actions/app-actions-types';
import {
  deleteBank,
  deleteEmail,
  deletePan
  // deletePhone,
  // toggleDefaultBank,
  // toggleDefaultEmail,
  // toggleDefaultPhone
} from '../../../actions/user-actions-types';
import {
  Header,
  RouteWrapper,
  ScreenBackground,
  ScrollView,
  VerifyAddressItem,
  VerifyBankItem,
  VerifyEmailItem,
  VerifyPanItem,
  VerifyPhoneItem,
  View
} from '../../../component';
// import Constants from '../../../constants';
import EventEmitter from '../../../utilities/EventEmitter';
import I18n from '../../../utilities/locale';

const VerifyAccount = () => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const {
    addressInfo: addressList = [],
    pan,
    bankAccounts,
    emails,
    phones
    // statuses = { ...Constants.InitialStatuses }
  } = user;

  // const {
  //   bankAccounts: bankAccountStatus,
  //   pan: panStatus,
  //   emails: emailsStatus,
  //   phones: phonesStatus,
  //   addresses: addressesStatus
  // } = statuses;

  useEffect(() => {
    onPressRetry();
  }, []);

  const onPressRetry = () => {
    EventEmitter.emit('updateMissingData');
  };

  // const DataNotArrived = () => {
  //   if (!resultArrived) return <Placeholder.MatchItemPlaceholder />
  //   return <ErrorMessage onPressRetry={onPressRetry} />
  // }

  const getAddressList = () => {
    EventEmitter.emit('updateAddress');
  };

  const getPhoneList = () => {
    EventEmitter.emit('updatePhoneList');
  };

  const getEmailList = () => {
    EventEmitter.emit('updateEmailList');
  };

  const getBankList = () => {
    EventEmitter.emit('updateBankList');
  };

  const getPan = () => {
    EventEmitter.emit('updatePan');
  };

  // const navigation = useNavigation()

  // const toggleAsDefaultBank = (id: any) => {
  //   const data = {
  //     id
  //   };
  //   dispatch(
  //     toggleDefaultBank({
  //       data,
  //       callback: ({ error }: { error: any }) => {
  //         if (!error) {
  //           dispatch(showToast(I18n.t('AddressToggled')));
  //           getBankList();
  //         }
  //       }
  //     })
  //   );
  // };

  // const toggleAsDefaultPhone = (id: any) => {
  //   const data = {
  //     id
  //   };
  //   dispatch(
  //     toggleDefaultPhone({
  //       data,
  //       callback: ({ error }: { error: any }) => {
  //         if (!error) {
  //           dispatch(showToast(I18n.t('AddressToggled')));
  //           getPhoneList();
  //         }
  //       }
  //     })
  //   );
  // };

  // const toggleAsDefaultEmail = (id: any) => {
  //   const data = {
  //     id
  //   };
  //   dispatch(
  //     toggleDefaultEmail({
  //       data,
  //       callback: ({ error }: { error: any }) => {
  //         if (!error) {
  //           dispatch(showToast(I18n.t('AddressToggled')));
  //           getEmailList();
  //         }
  //       }
  //     })
  //   );
  // };

  const onPressDeleteBank = (id: any) => {
    const data = {
      id
    };
    dispatch(
      deleteBank({
        data,
        callback: ({ error }: { error: any }) => {
          if (!error) {
            dispatch(showToast(I18n.t('DeletedSuccessfully')));
            getBankList();
          }
        }
      })
    );
  };

  // const onPressDeletePhone = (id: any) => {
  //   const data = {
  //     id
  //   };
  //   dispatch(
  //     deletePhone({
  //       data,
  //       callback: ({ error }: { error: any }) => {
  //         if (!error) {
  //           dispatch(showToast(I18n.t('DeletedSuccessfully')));
  //           getPhoneList();
  //         }
  //       }
  //     })
  //   );
  // };

  const onPressDeleteEmail = (id: any) => {
    const data = {
      id
    };
    dispatch(
      deleteEmail({
        data,
        callback: ({ error }: { error: any }) => {
          if (!error) {
            dispatch(showToast(I18n.t('DeletedSuccessfully')));
            getEmailList();
          }
        }
      })
    );
  };

  const onPressDeletePanCard = (id: any) => {
    const data = {
      id
    };
    dispatch(
      deletePan({
        data,
        callback: ({ error }: { error: any }) => {
          if (!error) {
            dispatch(showToast(I18n.t('DeletedSuccessfully')));
            getPan();
          }
        }
      })
    );
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  // const containerColor = {
  //   backgroundColor: VerifyAccountTheme.container
  // }

  // const containerWrapperColor = {
  //   // backgroundColor: VerifyAccountTheme.container
  // };

  // const divider = {
  //   backgroundColor: theme.divider
  // }

  // const note = {
  //   color: theme.note
  // }
  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={'KYC'} onClickBack={onClickBack} />
        <ScrollView className={'verify-account-scroll-container'}>
          <View>
            <VerifyPhoneItem
              list={phones !== undefined ? phones : []}
              onVerifySuccess={getPhoneList}
            />
          </View>
          <View>
            <VerifyEmailItem
              list={emails !== undefined ? emails : []}
              onVerifySuccess={getEmailList}
              onAddEmail={getEmailList}
              onPressDelete={onPressDeleteEmail}
            />
          </View>
          <View>
            <VerifyPanItem
              list={pan !== undefined && pan.name !== undefined ? [pan] : []}
              bankList={bankAccounts !== undefined ? bankAccounts : []}
              // onAddPancard={getPan}
              onPressDelete={onPressDeletePanCard}
            />
          </View>
          <View>
            <VerifyAddressItem list={addressList} onAddUpdateAddress={getAddressList} />
          </View>
          <View>
            <VerifyBankItem
              list={bankAccounts !== undefined ? bankAccounts : []}
              panList={pan !== undefined && pan.name !== undefined ? [pan] : []}
              // onAddBank={getBankList}
              onPressDelete={onPressDeleteBank}
            />
          </View>
        </ScrollView>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default VerifyAccount;
